/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import HttpBackend from 'i18next-http-backend';
import markdownJsx from 'i18next-markdown-jsx-plugin';

import { DefaultLanguage, SupportedLanguages } from '../utils/constants';
import config from './config';
import { areCookiesEnabled } from '../utils/cookies';

const { cache, translationsPath, legalTranslationsPath } = config;

export const Namespaces = {
  Common: 'common',
  Legal: 'legal',
};

i18next
  .use(ChainedBackend)
  .use(markdownJsx)
  .use(initReactI18next)
  .init({
    ns: Object.values(Namespaces),
    defaultNS: Namespaces.Common,
    supportedLngs: Object.values(SupportedLanguages),
    lng: DefaultLanguage,
    fallbackLng: DefaultLanguage,
    preload: [DefaultLanguage],
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      backends: [
        ...(areCookiesEnabled() ? [LocalStorageBackend] : []),
        HttpBackend, // platform
        HttpBackend, // legal-texts
      ],
      backendOptions: [
        cache,
        {
          loadPath: translationsPath,
          addPath: translationsPath,
          crossDomain: true,
        },
        {
          loadPath: legalTranslationsPath,
          addPath: legalTranslationsPath,
          crossDomain: true,
        },
      ],
    },
  });

export default i18next;
